import Tabs from './Tabs';

export default Tabs;



// WEBPACK FOOTER //
// ./scripts/blocks/Tabs/index.js